import {
  getTelLinkFromPhone,
  getWhatsappLinkFromPhone,
  rtrim,
} from "./components/utils.js";

export const menu = [
  {
    text: "PORTFÓLIO",
    to: "/portfolio",
  },
  {
    text: "SOBRE",
    to: "/sobre",
  },
  {
    text: "BLOG",
    to: "/blog",
  },
  {
    text: "CASTING",
    to: "/casting",
  },
  {
    text: "CONTATO",
    to: "/contato",
  },
];

export function getSocial(component) {
  if (!component.$rest) throw new Error();

  const social = [];

  if (component.informations.whatsapp) {
    component.informations.whatsapp = rtrim(
      component.informations.whatsapp,
      ";"
    );
    component.informations.whatsapp = rtrim(
      component.informations.whatsapp,
      ";"
    );
    let whatsappSplit = component.informations.whatsapp.split(";");

    if (Array.isArray(whatsappSplit)) {
      whatsappSplit.forEach(function (val) {
        social.push({
          title: val,
          link: getWhatsappLinkFromPhone(val),
          icon: "fab fa-whatsapp",
        });
      });
    } else {
      social.push({
        title: "WhatsApp",
        link: getWhatsappLinkFromPhone(component.informations.whatsapp),
        icon: "fab fa-whatsapp",
      });
    }
  }
  if (component.informations.vimeo)
    social.push({
      title: "Vimeo",
      link: component.informations.vimeo,
      icon: "fab fa-vimeo-v",
    });
  if (component.informations.youtube)
    social.push({
      title: "YouTube",
      link: component.informations.youtube,
      icon: "fab fa-youtube",
    });
  if (component.informations.instagram)
    social.push({
      title: "Instagram",
      link: component.informations.instagram,
      icon: "fab fa-instagram",
    });
  if (component.informations.facebook)
    social.push({
      title: "Facebook",
      link: component.informations.facebook,
      icon: "fab fa-facebook-f",
    });

  return social;
}

export function getContact(component) {
  const contact = [];

  if (component.informations.address)
    contact.push({
      title: component.informations.address,
      link: component.informations.maps,
      icon: "fa fa-map-marker-alt",
    });
  if (component.informations.tel) {
    component.informations.tel = rtrim(component.informations.tel, ";");
    let telSplit = component.informations.tel.split(";");

    if (Array.isArray(telSplit)) {
      let tel = [];
      telSplit.forEach(function (val) {
        tel.push({
          title: val,
          link: getTelLinkFromPhone(val),
          icon: "fas fa-phone-alt",
        });
      });

      contact.push(tel);
    } else {
      contact.push({
        title: component.informations.tel,
        link: getTelLinkFromPhone(component.informations.tel),
        icon: "fas fa-phone-alt",
      });
    }
  }
  if (component.informations.email)
    contact.push({
      title: component.informations.email,
      link: "mailto:" + component.informations.email,
      icon: "fas fa-envelope",
    });

  return contact;
}
